"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationOfferClaimStatus = void 0;
var AssignationOfferClaimStatus;
(function (AssignationOfferClaimStatus) {
    AssignationOfferClaimStatus[AssignationOfferClaimStatus["Accepted"] = 0] = "Accepted";
    AssignationOfferClaimStatus[AssignationOfferClaimStatus["Confirmed"] = 1] = "Confirmed";
    AssignationOfferClaimStatus[AssignationOfferClaimStatus["Declined"] = 2] = "Declined";
    AssignationOfferClaimStatus[AssignationOfferClaimStatus["Cancelled"] = 3] = "Cancelled";
})(AssignationOfferClaimStatus || (exports.AssignationOfferClaimStatus = AssignationOfferClaimStatus = {}));
//# sourceMappingURL=assignation-offer-claim-status.enum.js.map